import gettext from '@sdk/lang/gettext';

import {
  BUSINESS_DOWNGRADE_REASONS,
  PREMIUM_CANCEL_REASONS,
  BUSINESS_CANCEL_REASONS,
  PREMIUM_PAUSE_REASONS,
} from '@web/account/constants';

import { DowngradeMode } from './downgradeReason.types';

export const downgradeReasonsRequireText = BUSINESS_DOWNGRADE_REASONS.reduce((agg, reason) => {
  agg[reason.id] = reason.textRequired;
  return agg;
}, {});

export const premiumCancelReasonsRequireText = PREMIUM_CANCEL_REASONS.reduce((agg, reason) => {
  agg[reason.id] = reason.textRequired;
  return agg;
}, {});

export const businessCancelReasonsRequireText = BUSINESS_CANCEL_REASONS.reduce((agg, reason) => {
  agg[reason.id] = reason.textRequired;
  return agg;
}, {});

export const pauseReasonsRequireText = PREMIUM_PAUSE_REASONS.reduce((agg, reason) => {
  agg[reason.id] = reason.textRequired;
  return agg;
}, {});

export const getReasons = (mode: DowngradeMode, isBusiness: boolean) => {
  if (mode === DowngradeMode.cancel) {
    return isBusiness ? BUSINESS_CANCEL_REASONS : PREMIUM_CANCEL_REASONS;
  }

  if (mode === DowngradeMode.downgrade) {
    return BUSINESS_DOWNGRADE_REASONS;
  }

  return PREMIUM_PAUSE_REASONS;
};

export const getRequireTextDict = (mode: DowngradeMode, isBusiness: boolean) => {
  if (mode === DowngradeMode.cancel) {
    return isBusiness ? businessCancelReasonsRequireText : premiumCancelReasonsRequireText;
  }

  if (mode === DowngradeMode.downgrade) {
    return downgradeReasonsRequireText;
  }

  return pauseReasonsRequireText;
};

export const getTitle = (mode: DowngradeMode) => {
  if (mode === DowngradeMode.downgrade) {
    return gettext('What is the primary reason for downgrading your account?');
  }

  if (mode === DowngradeMode.cancel) {
    return gettext('What is the primary reason for cancelling your subscription?');
  }

  return gettext('What is the primary reason for pausing your subscription?');
};
